var React = require('react');

function LongArrowAltRight (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M12.1 216H314v80H12.1a12 12 0 0 1-12-12v-56a12 12 0 0 1 12-12z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M355 153l86.06 86.09a24 24 0 0 1 0 33.94L355 359.05c-15.12 15.12-41 4.41-41-17V170c0-21.42 25.89-32.13 41-17z","className":"fa-primary","key":2})]);
}

LongArrowAltRight.defaultProps = {"viewBox":"0 0 448 512","className":"icon"};

module.exports = LongArrowAltRight;

LongArrowAltRight.default = LongArrowAltRight;
